import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Callout, Loader } from '@node-space/storybook-components'
import { useWalletContext } from 'hooks/context'
import { useDepositAccountsQuery } from 'hooks/queries'
import { useIsActiveWallet } from 'hooks/useActiveWallets'
import MultipleDepositDetails from 'pages/Wallets/components/Deposit/components/MultipleDepositDetails'
import SingleDepositDetails from 'pages/Wallets/components/Deposit/components/SingleDepositDetails'
import { DepositBankAccount } from 'types/BankAccountsDetails'

export const FiatExtendedDetails = () => {
  const wallet = useWalletContext()
  const {
    isError,
    isFetching: isFetchingDepositDetails,
    data: accountDetails,
  } = useDepositAccountsQuery(wallet?.id?.toString(), true)

  const { t } = useTranslation()
  const isSelectedWalletActive = useIsActiveWallet(wallet)

  return isFetchingDepositDetails ? (
    <div className="flex justify-center">
      <Loader theme="dark" size="large" />
    </div>
  ) : (
    <>
      {isError ? (
        <Callout state="error" message={t('oopsSomethingWentWrongFetchDespoitDetails')} />
      ) : (
        isSelectedWalletActive &&
        (accountDetails?.length > 1 ? (
          <Box padding={24} className="max-w-mediumLarge">
            <MultipleDepositDetails bankAccounts={accountDetails} wallet={wallet} />
          </Box>
        ) : (
          <Box padding={24} className="max-w-mediumLarge">
            <SingleDepositDetails
              account={accountDetails?.[0] as DepositBankAccount}
              wallet={wallet}
            />
          </Box>
        ))
      )}
    </>
  )
}
